export default __webpack_public_path__ + "assets/_Chapters/CTeileSortiment/Messtechnik/kaefer.jpg";